module.exports = __webpack_public_path__ + "img/bg_color - Copy.9b3ddd99.png";